export const formatValue = (v, fallback = "—") => {
  if (!Number.isFinite(v)) return fallback;
  if (v > 0 && v < 0.01) return "<0.01";
  return v.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatGap = (v, fallback = "—") => {
  if (!Number.isFinite(v)) return fallback;
  const sign = v > 0 ? "+" : "";
  return `${sign}${formatValue(v, fallback)}`;
};

export const formatEmissionValue = (v, fallback = "—") => {
  return formatValue(v, fallback);
};

export const formatPercentage = (v, fallback = "—") => {
  if (!Number.isFinite(v)) return fallback;
  return `${formatValue(v, fallback)}%`;
};
